module.exports = __webpack_public_path__ + "img/avatar-s-2.93c7a17a.png";